import React from "react";
import AppButton from "./AppButton";
import AppTooltip from "./AppTooltip";
import { IconClose, IconEdit, IconSave } from "../icons";

const AppEditActions = ({
  editing = false,
  dirty = false,
  saving = false,
  editDisabled = false,
  onEdit,
  onCancel,
  onSave,
  editLabel = "Bearbeiten",
  cancelLabel = "Bearbeitung abbrechen",
  saveLabel = "Änderungen speichern",
  savingLabel = "Änderungen werden gespeichert",
  size = "md",
  editVariant = "muted",
}) => {
  if (!editing) {
    if (!onEdit) return null;
    return (
      <AppTooltip content={editLabel}>
        <AppButton
          variant={editVariant}
          size={size}
          iconOnly
          aria-label={editLabel}
          onClick={onEdit}
          disabled={editDisabled}
        >
          <IconEdit />
        </AppButton>
      </AppTooltip>
    );
  }

  const resolvedSaveLabel = saving ? savingLabel : saveLabel;

  return (
    <>
      <AppTooltip content={cancelLabel}>
        <AppButton
          variant="neutral"
          size={size}
          iconOnly
          aria-label={cancelLabel}
          onClick={onCancel}
          disabled={saving}
        >
          <IconClose />
        </AppButton>
      </AppTooltip>
      <AppTooltip content={resolvedSaveLabel}>
        <AppButton
          variant="primary"
          size={size}
          iconOnly
          aria-label={resolvedSaveLabel}
          onClick={onSave}
          disabled={saving || !dirty}
        >
          <IconSave />
        </AppButton>
      </AppTooltip>
    </>
  );
};

export default AppEditActions;
